(function () {
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const prefetched = new Set();
  let hoverTimer = null;

  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;

  function getEligibleUrl(target) {
    const link = target.closest?.('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return null;

    const url = new URL(link.href, window.location.href);

    if (url.origin !== window.location.origin) return null;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return null;
    if (url.hash && url.pathname === window.location.pathname && url.search === window.location.search) return null;
    if (/\/(cart|checkout|account\/logout)(\/|$)/.test(url.pathname)) return null;

    return url.href;
  }

  function prefetch(url) {
    if (!url || prefetched.has(url)) return;

    prefetched.add(url);

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
  }

  document.addEventListener('pointerover', (event) => {
    const url = getEligibleUrl(event.target);
    if (!url) return;

    window.clearTimeout(hoverTimer);
    hoverTimer = window.setTimeout(() => prefetch(url), 65);
  }, { passive: true });

  document.addEventListener('pointerout', () => {
    window.clearTimeout(hoverTimer);
  }, { passive: true });

  document.addEventListener('touchstart', (event) => {
    prefetch(getEligibleUrl(event.target));
  }, { passive: true });
})();
